export const LANGUAGES = ['en', 'es', 'cn'];
export const DEFAULT_LANGUAGE = 'en';
export const LANGUAGE_LABELS = {
  en: 'English',
  es: 'Spanish',
  cn: 'Chinese',
};
